export default "__VITE_ASSET__CrGI0qtf__"